import { LaunchSources, RoomTypes } from '~analytics/types';

import { sendLaunchTrueFalseEvent } from '../index';
import { EventAdapter } from './EventAdapter';

export class LaunchTrueFalseEventAdapter extends EventAdapter {
  protected intercomEventKey = 'launch-true-false';
  protected amplitudeEventFunction = sendLaunchTrueFalseEvent;

  constructor(
    isRosteredRoom: boolean,
    launchSource: LaunchSources = LaunchSources.LaunchScreen
  ) {
    super();

    try {
      const roomType = isRosteredRoom
        ? RoomTypes.RosteredRoom
        : RoomTypes.OpenRoom;
      this.eventData = {
        room_type: roomType,
        launch_source: launchSource,
      };
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }
}
